import API from "../API Service/ApiCalls";
import ApiService from "../API Service/ApiService";
import { appConstants } from "../Pages/AppConstants";
var apiService = new ApiService();

class TaskServiceController {

  getTasksList = async () => {
    var response = await apiService.getData(API.taskList, { "clientId": appConstants.clientId, "isPublished": false });
    var json = await response.json();
    return json;
  };

  getTasksListforDropdown = async () => {
    var response = await apiService.getData(API.dropdownTasks, {});
    var json = await response.json();
    return json;
  };

  getTaskParametersList = async (id) => {
    var response = await apiService.getData(API.taskParameterList, { "taskId": id });
    var json = await response.json();
    return json;
  }

  publishTasks = async (id) => {
    var response = await apiService.postData(API.publishTask, { "id": id });
    return response;

  };
  
  deleteTasks = async (id) => {
    var response = await apiService.postData(API.deleteTask, { "id": id });
    return response;
  };

  addUpdateTasks = async (requestBody) => {
    var response = await apiService.postData(API.addUpdateTask, {}, requestBody);
    return response;
  };

}
export default TaskServiceController;